import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import Logout from '@mui/icons-material/Logout'
import Close from '@mui/icons-material/Close'
import {
  Badge,
  Breadcrumbs,
  Drawer,
  Grid,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material'
import { useEffect, useState } from 'react'
import { HiMenu, HiOutlineBell } from 'react-icons/hi'
import { Link } from 'react-router-dom'
import { Box, Button, Card, CardHeader, IconButton } from '../../components'
import { useAuth } from '../../lib/auth'
import { useDeleteNotification, useLoadNotifications } from '../../services'
import { formatCurrency, formatDate } from 'utils'
import { useLayoutContext } from '../layout.context'
import { API_URL } from 'config'
import { useTheme } from '@mui/material/styles'

type Anchor = 'right'

const AccessApiButton = () => {
  if (process.env.NODE_ENV !== 'development') return null
  return (
    <Button
      onClick={() =>
        window.open(API_URL + '/docs', '_blank', 'noopener,noreferrer')
      }
    >
      Acessar API Docs
    </Button>
  )
}

export const Header = () => {
  const theme = useTheme()
  const { setShowSidebar, showSidebar, breadcrumbs } = useLayoutContext()
  const [state, setState] = useState({ right: false })

  const { data: notifications } = useLoadNotifications({})
  const { mutate: deleteNotification } = useDeleteNotification()

  const [notifies, setNotifies] = useState(0)

  const { logout, user } = useAuth()

  const toggleDrawer = (anchor: Anchor, open: boolean) => () => {
    setState({ ...state, [anchor]: open })
  }

  useEffect(() => {
    setNotifies(
      notifications?.data.filter((ele: any) => ele.VISUALIZACAO === false)
        .length
    )
  }, [notifications])

  return (
    <Box
      sx={{
        width: '100%',
        position: 'fixed',
        background: '#10b981',
        zIndex: 1100
      }}
    >
      <div style={{ background: theme.palette.primary.main }}>
        <Toolbar variant="dense" style={{ justifyContent: 'space-between' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 12
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 1 }}
              onClick={() => setShowSidebar(!showSidebar)}
            >
              <HiMenu size={24} style={{ color: '#ffffff' }} />
            </IconButton>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src="/logo-branco.png" alt="logo" width={65} />
            </div>
            {breadcrumbs.length > 0 && (
              <div
                style={{
                  width: 1,
                  height: 20,
                  backgroundColor: 'rgba(255,255,255,0.4)'
                }}
              />
            )}
            {breadcrumbs.length > 0 && (
              <Breadcrumbs
                aria-label="breadcrumb"
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  '& .MuiBreadcrumbs-separator': {
                    color: 'rgba(255,255,255,0.6)'
                  },
                  ml: 1
                }}
              >
                {breadcrumbs.map((crumb, index) => {
                  const isLast = index === breadcrumbs.length - 1
                  if (isLast) {
                    return (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <Typography
                          sx={{
                            color: '#ffffff',
                            fontWeight: 600,
                            fontSize: 14
                          }}
                        >
                          {crumb.label}
                        </Typography>
                        {crumb.copyText && (
                          <Tooltip title="Copiar código">
                            <ContentCopyIcon
                              sx={{
                                color: 'rgba(255,255,255,0.8)',
                                fontSize: 14,
                                cursor: 'pointer',
                                '&:hover': {
                                  color: '#ffffff'
                                }
                              }}
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  crumb.copyText || ''
                                )
                              }}
                            />
                          </Tooltip>
                        )}
                      </div>
                    )
                  }
                  return crumb.to ? (
                    <Link
                      key={index}
                      to={crumb.to}
                      style={{
                        color: 'rgba(255,255,255,0.8)',
                        textDecoration: 'none',
                        fontSize: 14
                      }}
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <Typography
                      key={index}
                      sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 14 }}
                    >
                      {crumb.label}
                    </Typography>
                  )
                })}
              </Breadcrumbs>
            )}
          </div>
          <div className="flex">
            {user?.role === 'A' && (
              <IconButton onClick={toggleDrawer('right', true)}>
                <Badge badgeContent={notifies} color="error">
                  <HiOutlineBell size={24} color="#ffffff" />
                </Badge>
              </IconButton>
            )}

            <AccessApiButton />

            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label=""
              style={{ marginLeft: 10 }}
              onClick={() => logout()}
            >
              <Logout style={{ color: '#ffffff' }} />
            </IconButton>
          </div>
        </Toolbar>
      </div>
      {/* Notificações */}
      <Drawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer('right', false)}
      >
        <Box sx={{ width: { md: 400 }, padding: { xs: 1, md: 3 } }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <CardHeader title="Notificações" />
            <Box
              sx={{
                cursor: 'pointer',
                position: 'fixed',
                right: 0,
                top: 0,
                paddingRight: { xs: 0, md: 4 },
                paddingTop: { xs: 0, md: 1.5 }
              }}
            >
              <IconButton onClick={toggleDrawer('right', false)}>
                <Close />
              </IconButton>
            </Box>
          </div>
          {notifications?.data.map((notification: any) => (
            <div key={notification.CD_ORCAMENTO}>
              {notification?.VISUALIZACAO === true ? (
                <div style={{ display: 'none' }}></div>
              ) : (
                <div>
                  <Card
                    sx={{
                      visibility: { xs: 'visible', lg: 'visible' },
                      marginBottom: 2,
                      padding: 2
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <div>
                          <Typography variant="caption">Proposta</Typography>
                        </div>
                        <div>
                          <Typography
                            variant="caption"
                            sx={{ fontSize: 14, fontWeight: 500 }}
                          >
                            <Link
                              style={{
                                textDecoration: 'none',
                                color: '#0C95EB'
                              }}
                              to={`/orders/${notification.CD_ORCAMENTO}/details`}
                              onClick={() => {
                                toggleDrawer('right', false)
                                deleteNotification(notification.CD_ORCAMENTO)
                              }}
                            >
                              {notification.CD_ORCAMENTO}
                            </Link>
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div>
                          <Typography variant="caption">Data</Typography>
                        </div>
                        <div>
                          <Typography
                            variant="caption"
                            sx={{ fontSize: 14, fontWeight: 500 }}
                          >
                            {formatDate(notification.DT_HORA)}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={8}>
                        <div>
                          <Typography variant="caption">Cliente</Typography>
                        </div>
                        <div>
                          <Typography
                            variant="caption"
                            sx={{ fontSize: 14, fontWeight: 500 }}
                          >
                            {notification.NOME_CLIENTE}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div>
                          <Typography variant="caption">Total</Typography>
                        </div>
                        <div>
                          <Typography
                            variant="caption"
                            sx={{ fontSize: 14, fontWeight: 500 }}
                          >
                            {formatCurrency(notification.TOTAL)}
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </div>
              )}
            </div>
          ))}
        </Box>
      </Drawer>
    </Box>
  )
}
